import { useMutation } from '@tanstack/react-query'
import { lydiaPageService } from 'commons/services/lydiaPageService'
import { moneyPotService, type CreateAISRequestResponse } from 'commons/services/moneyPotService'

export type CreateAISRequestMutationParams = {
	source: 'money_pot' | 'lydia_page'
	identifier: string
	amount: number
	iban: string
	recipientName: string
}

export const useCreateAISRequest = (source: 'money_pot' | 'lydia_page') => {
	return useMutation<CreateAISRequestResponse, Error, CreateAISRequestMutationParams>({
		mutationFn: ({ identifier, amount, iban, recipientName }) => {
			if (source === 'money_pot') {
				return moneyPotService.createAISRequest({
					slug: identifier,
					amount,
					iban,
					recipientName
				})
			}
			return lydiaPageService.createAISRequest({
				pageTag: identifier,
				amount,
				iban,
				recipientName
			})
		}
	})
}
